export const CHAT = {
    SET_CHAT_ID: 'SET_CHAT_ID',
    SET_TYPE_CHAT: 'SET_TYPE_CHAT',
    SET_ADD_MESSAGES_SENT_ARR: 'SET_ADD_MESSAGES_SENT_ARR',
    REMOVE_FIRST_MATCHING_MESSAGE: 'REMOVE_FIRST_MATCHING_MESSAGE',
    CLEAR_SENT_ARR: 'CLEAR_SENT_ARR',
};
